import React, {Component} from 'react'
import './newActivityBaseInfostyle.css';
import success from './success.png';
import './plansToplatform.css';
import { message } from 'antd';
import {MediaEditableTagGroup} from "./PlansToplatform";
import {getMediaByIds} from "../../actions";
import {Scrollbars} from "react-custom-scrollbars";

class NewsActivityComplete extends Component {

    state = {
        medias:[]
    }

    constructor(props) {
        super(props);

        if(this.props.data){
            this.loadData(this.props.data.mediaIds);
        }
    }

    componentDidMount(){
        if(this.props.majorProjectData){
            this.setState({
                medias: this.props.majorProjectData.medias
            })
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.data){
            this.loadData(nextProps.data.mediaIds);
        }
    }

    loadData(mediaIds){
        if(mediaIds && (mediaIds.length > 0)){
            getMediaByIds(mediaIds).then(res=>{
                this.setState({medias:res.data});
            }).catch(err=>{
                console.error(err);
                message.error("媒体加载出错");
            })
        }
    }

    renderTaskContent(){
        let title = "";
        let date = "";
        if(this.props.data){
           title = this.props.data.title;
           date = window.formatDate(this.props.data.interviewDate)
        }
        return (
            <>
                <tr>
                    <td width={64} className={"activity_success_label_txt"}>活动名称</td>
                    <td style={{ paddingLeft: "30px", fontSize: "16px", color: "#6c748b" }}><div title={title} className={"text-pointer"} style={{ maxWidth: "880px" }}><b>{title}</b></div></td>
                </tr>
                <tr>
                    <td className={"activity_success_label_txt"}>任务时间</td>
                    <td style={{ paddingLeft: "30px", fontSize: "16px", color: "#6c748b" }}>{date}</td>
                </tr>
                <tr>
                    <td className={"activity_success_label_txt"}>拟发平台</td>
                    <td style={{ paddingLeft: "30px" }} valign={"middle"}>
                        <MediaEditableTagGroup getShowTags={() => { }}
                            closable={false}
                            style={{ height: "40px" }}
                            dataSource={this.state.medias} />
                    </td>
                </tr>
            </>
        )
    }

    renderProjectContent(){
        return (
            <>
                <tr>
                    <td width={64} className={"activity_success_label_txt"}>项目名称</td>
                    <td style={{ paddingLeft: "30px", fontSize: "16px", color: "#6c748b" }}><div title={this.props.majorProjectData.title} className={"text-pointer"} style={{ maxWidth: "880px" }}><b>{this.props.majorProjectData.title}</b></div></td>
                </tr>
                <tr>
                    <td className={"activity_success_label_txt"} style={{ whiteSpace: 'nowrap' }}>项目负责人</td>
                    <td style={{ paddingLeft: "30px", fontSize: "16px", color: "#6c748b" }}>{this.props.majorProjectData.manager}</td>
                </tr>
            </>
        )
    }

    renderTopicContent(){
        const { topicSelection } = this.props.topicSelectionData;
        return(
            <>
            <tr>
                <td width={64} className={"activity_success_label_txt"}>选题名称</td>
                <td style={{ paddingLeft: "30px", fontSize: "16px", color: "#6c748b" }}><div title={topicSelection.tsName} className={"text-pointer"} style={{ maxWidth: "480px" }}><b>{topicSelection.tsName}</b></div></td>
            </tr>
            <tr>
                <td className={"activity_success_label_txt"} style={{ whiteSpace: 'nowrap'}}>联系人</td>
                <td style={{ paddingLeft: "30px", fontSize: "16px", color: "#6c748b" }}>{topicSelection.tsContactsName}</td>
            </tr>
            <tr>
                <td className={"activity_success_label_txt"} style={{ whiteSpace: 'nowrap'}}>联系方式</td>
                <td style={{ paddingLeft: "30px", fontSize: "16px", color: "#6c748b" }}>{topicSelection.tsContactsPhone}</td>
            </tr>
        </> 
        )

    }

    render() {
        const { type } = this.props;
        return <div className={"newActivityBaseInfo_container"} style={{height:"500px", width: '100%'}}>
            <Scrollbars
                autoHeightMax={500}
            >
            <div style={{height:"105px",marginTop:"40px",paddingLeft:"47px"}}>
                <img src={success} style={{marginRight:"13px"}} alt="" />
                <b className={"activity_success_txt"}>创建成功</b>
            </div>
            <div style={{paddingLeft:"40px"}}>
                <table cellPadding={0} cellSpacing={0} border={0}>
                    <tbody>
                        {
                            type === '专题项目' ?  this.renderProjectContent() : ( type === '新闻策划' ? this.renderTaskContent() : ( type === '选题管理' ? this.renderTopicContent() : '') )
                        }
                    </tbody>
                </table>
            </div>
            </Scrollbars>
        </div>
    }
}
export default  NewsActivityComplete;